module.exports = __webpack_public_path__ + "static/media/everyday_digital_and_weekend_papers_june23.6d2f02e1.png";